import { Dialog } from "@mui/material";
import { useState } from "react";
import MultipleChipsField from "../../BaseInputs/MultipleChipsField";
import DialogContentSelectGeneric from "../DialogsContents/DialogContentGeneric";

interface IPraga {
    id: number;
    nome_cientifico: string;
    nome_popular: string;
}

interface SelectPragaProps {
    value: IPraga | IPraga[] | null;
    onChange: (arg: IPraga | IPraga[] | null) => void;
    error?: boolean;
    required?: boolean;
    unique_select?: boolean;
}

export default function SelectPraga({
                                        value,
                                        onChange,
                                        required = false,
                                        error = false,
                                        unique_select = false,
                                    }: SelectPragaProps) {
    const [openModal, setOpenModal] = useState(false);

    const handleClose = () => setOpenModal(false);

    // Normalize value for chips field
    const normalizedValue = value
        ? Array.isArray(value)
            ? value
            : [value]
        : [];

    return (
        <>
            <MultipleChipsField
                value={normalizedValue.map((item) => ({
                    ...item,
                    nome: item.nome_popular, // Map 'nome_popular' to 'nome'
                }))}
                required
                label="Praga"
                formatChipLabel={(item) => `${item.id} - ${item.nome_popular}`}
                onClick={() => setOpenModal(true)}
                error={!!error}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {openModal && (
                <Dialog
                    fullWidth
                    maxWidth="md"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        handleClose={handleClose}
                        multiple={!unique_select}
                        possuiBtnLimpar
                        title="Selecionar Praga"
                        queryPath="/receituario-agronomico/pragas/pesquisar-praga"
                        getItemKey={(item: any) => item?.id ?? 0}
                        getItemLabel={(item: any) => item ? `${item.id} - ${item.nome_popular}` : ''}
                        defaultValue={normalizedValue}
                        onChange={(selected: any) => {
                            if (unique_select) {
                                const arr = Array.isArray(selected) ? selected : selected ? [selected] : [];
                                onChange(arr.length > 0 ? arr[0] : null);
                            } else {
                                onChange(Array.isArray(selected) ? selected : selected ? [selected] : []);
                            }
                            handleClose();
                        }}
                    />
                </Dialog>
            )}
        </>
    );
}